import { selectLoader } from '../selectors';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import i18next from 'i18next';

const mapStateToProps = (state) => ({
  fetching: selectLoader(state).status,
});

const enchance = compose(connect(mapStateToProps));

const RenderIfView = ({ notEmpty, isExists, cond, children, placeholder, fetching, noText }) => {
  let render;

  if (notEmpty) {
    render = notEmpty.find((item) => item.length > 0);
  } else if (isExists) {
    render = isExists;
  } else if (cond) {
    render = cond;
  }

  if (render) {
    return children;
  }

  return renderEmpty(placeholder, fetching, noText);
};

const renderEmpty = (placeholder, fetching, noText) => {
  if (noText || !fetching) return null;
  if (fetching) return `${i18next.t('cabinet.downloading')}...`;
  if (!fetching && placeholder) return placeholder;
  if (!fetching && !placeholder) return null;
};

export const RenderIf = RenderIfView;
export const RenderIfConnected = enchance(RenderIfView);
